export enum WorkerAction {
  MontecarloRetirement = 0,
  ParallelMontecarloRetirement = 1,
}

export interface TaskCreationResponse {
  resultPromise: Promise<string>,
  cancelTask: ()=>void,
};

export interface TaskInput {
  serializedParameters: string,
  reportProgress: TaskProgressListener,
}

export type RequestId = string;
export type TaskProgressListener = (completionRatio: number) => void;
export type TaskHandler = (input: TaskInput) => Promise<string>;

export enum TaskStatus {
  Complete = 0,
  Progressing = 1,
  Failed = 100,
}

export interface TaskCreationRequest {
  action: string,
  uuid: RequestId,
  serializedParameters: string,
};

export type TaskResponseMessage = {
  uuid: RequestId;
  status: TaskStatus;
  serializedResult: string;
  progress: number;
  excuse: string;
};